module.exports = __webpack_public_path__ + "img/qrcode_wechat.37320892.jpg";